import Vue from 'vue'
import Template from './index.vue'

const CouponLottery = Vue.extend(Template)

export function templateCouponLotteryVue({ module }) {
  const couponLottery = new CouponLottery({
    propsData: {
      module
    }
  }).$mount()
  return couponLottery.$el
}
